/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCompanyApiKeyFromJSON, StreemApiCompanyApiKeyToJSON, } from './';
export function StreemApiCreateCompanyApiKeyResponseFromJSON(json) {
    return StreemApiCreateCompanyApiKeyResponseFromJSONTyped(json, false);
}
export function StreemApiCreateCompanyApiKeyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiKey': !exists(json, 'api_key') ? undefined : StreemApiCompanyApiKeyFromJSON(json['api_key']),
    };
}
export function StreemApiCreateCompanyApiKeyResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'api_key': StreemApiCompanyApiKeyToJSON(value.apiKey),
    };
}
//# sourceMappingURL=StreemApiCreateCompanyApiKeyResponse.js.map